const insuranceResources = {
  ru: {
    sos: {
      'Дата, время и место осмотра будет согласовано с Вами в течение 3 рабочих дней. Ожидайте звонка от Контакт-центра АО «СК «Alatau City Garant».':
        'Дата, время и место осмотра будет согласовано с Вами в течение 3 рабочих дней. Ожидайте звонка от Контакт-центра АО «СК «Alatau City Garant».',
      dtp: {
        title: 'Как оформить онлайн страховую выплату после ДТП',
        video: 'Видеоинструкция по оформлению страховой выплаты онлайн',
      },
      notifications: {
        success: {
          applicationCreated: 'Ваша заявка ',
          applicationCreated2: 'успешно создана и принята в обработку.',
          applicationCreatedFull:
            'Ваша заявка успешно создана и принята в обработку.',
          app1: 'Ваше извещение успешно отправлено, и принято в обработку',
          app2: 'Ваша заявка успешно отправлена, и принята в обработку!',
        },
      },
      instructions: {
        waitThreeDays:
          'После отправки вам необходимо подождать 3 (три) рабочих дня. Если: ',
        finalResponseUnsatisfactory:
          'Если страховая компания выслала вам письмо с окончательным ответом на вашу жалобу, который вас не удовлетворяет:',
        noFinalResponse:
          'Или страховая компания не выслала вам окончательного ответа в течение трех рабочих дней:',
        contactOmbudsman:
          "По истечению трех дней после отправки извещения, вы можете обратиться напрямую к страховому омбудсману, заполнив 'Заявление об урегулировании взаимоотношений'.",
      },
      submissionStatus: {
        notificationSent: 'Извещение успешно отправлено и принято в обработку!',
        ombudsmanApplicationSent:
          'Вы можете отправить заявление напрямую страховому омбудсману через 3 рабочих дня с момента отправки извещения.',
        downloadNote: 'Скачать шаблон извещения',
        downloadApp: 'Скачать шаблон заявления',
        attachNote: 'Прикрепить извещение омбудсману',
        attachApp: 'Прикрепить заявление омбудсману',
      },
      website: {
        title: 'Сайт страхового омбудсмана',
        claim: 'Обращение к омбудсману',
        enterEmail:
          'Введите адрес вашей почты для получения обратной связи от Страхового Омбудсмана:',
        selectProcedure: 'Выберите порядок урегулирования',
        withPoliceReport: 'При наличии протокола ГАИ',
        europrotocol: 'Европротокол',
        soon: 'Скоро',
        withoutPoliceCall: 'Без вызова ГАИ',
        next: 'Далее',
        close: 'Закрыть',
      },
      commissioner: {
        title:
          'Цифровой аварийный комиссар доступен с 9:00 до 18:00 по будням*',
        authorizationRequired: 'Требуется авторизация*',
        vehicleCalculator: 'Калькуляторы износа и пробега ТС',
        insuredEvent1: 'Страховой случай',
        insuredEvent2: 'Документы',
        insuredEvent3: 'Данные потерпевшей стороны',
        insuredEvent4: 'Осмотр или фото',
      },
      accidentDetails: {
        dateAndTime: 'Дата и время происшествия',
        insurance: 'Договор страхования',
        sendApplicationAs: 'Подать заявку как:',
        guiltyPerson: 'Виновник',
        victim: 'Потерпевший',
        selectPolicy: 'Выберите полис',
        guiltyPersonIIN: 'ИИН виновника',
        guiltyPersonVehicleNumber: 'Гос. номер ТС виновника',
        enterAccidentAddress: 'Введите адрес происшествия и опишите ситуацию',
        note: 'Внимание!',
        onlineApplicationNote:
          'Оформление онлайн-заявки на страховой случай, доступно только при условии одного потерпевшего. Если в ДТП количество потерпевших превышает одного, просим Вас напрямую обратиться в наш ближайший офис.',
        trafficPoliceProtocol: 'Постановление суда',
        notRequiredAtTheTime: '* Необязательно на момент обращения',
        identityCard: 'Удостоверение личности *',
        techPassport: 'Техпаспорт *',
        trafficPoliceMaterials: 'Материалы ГАИ *',
        mandatoryToAttach: '* Обязательно к прикреплению',
        addDocument: 'Добавить документ',
        enterVictimDetails: 'Введите данные потерпевшей стороны',
        victimIIN: 'ИИН потерпевшего',
        victimContacts: 'Контакты потерпевшего',
        damagedVehicleOwnerIIN: 'ИИН владельца пострадавшего ТС',
        damagedVehicleNumber: 'Номер пострадавшего ТС',
        owner: 'Владелец',
        attorneyInFact: 'Представитель по доверенности',
        accidentParticipants: 'Участники ДТП',
        insuranceCompany: 'Страховая компания',
        lawyer: 'Адвокат',
        scheduleInspectionOrPhotos:
          'Вам нужно назначить осмотр или вы сами сфотографируете ТС?',
        scheduleInspection: 'Назначить осмотр',
        takePhotosOnMyOwn: 'Сфотографировать самому',
        selectInspectionDetails: 'Выберите дату, регион и адрес для осмотра',
        scheduledInspectionDate: 'Дата осмотра',
        dearClient: 'Уважаемый клиент!',
        amountWillBePaid1: 'Страховая сумма будет выплачена в течении ',
        amountWillBePaid2: '15 рабочих дней ',
        amountWillBePaid3: 'после сбора обязательных документов!',
        collectionOfDocuments: 'Сбор документов',
        inspectionDateCannotExceed:
          'Дата планируемого осмотра не может превышать 5 дней от даты подачи заявки',
        inspectionRegion: 'Регион проведения осмотра',
        inspectionAddress: 'Адрес проведения осмотра',
        fillInInspectionRegionAndAddress:
          'Пожалуйста, заполните регион и адрес осмотра',
        vehiclePhotos: 'Фотографии транспортного средства',
        frontView: 'Вид спереди',
        backView: 'Вид сзади',
        leftView: 'Вид слева',
        rightView: 'Вид справа',
        reviewPhotosAndTakeNewOnesIfNecessary:
          'Просмотрите фотографии и, если необходимо, сделайте новые',
        applicationForAssessment: 'Заявление на оценку',
        checkCorrectnessOfFilledData:
          'Проверьте правильность заполненных данных',
        change: 'Изменить',
        applicantDetails: 'Данные заявителя',
        victimDetails: 'Данные потерпевшего',
        eventInsured: 'Страховой случай',
        inspection: 'Осмотр',
        submitApplication: 'Оставить заявку',
        scheduleInspectionConfirmation:
          'Вы уверены что хотите назначить осмотр вашего ТС?',
        scheduleInspectionConfirmation2: ' число?',
        sendingData: 'Отправка данных...',
        applicationSentAndUnderConsideration:
          'Заявка успешно отправлена и находится на рассмотрении',
        applicationNumber: 'Ваша заявка №',
        applicationNumber2: ' успешно создана, и принята в обработку',
        listofApplications: 'Список заявок',
        homepage: 'Главная страница',
      },
      errors: {
        enterCorrectTime: 'Введите корректное время',
        selectRegion: 'Выберите регион',
        selectContractNumber: 'Выберите номер договора',
        selectDateAndTimeOfAccident: 'Выберите дату и время происшествия',
        fillOutDescription: 'Заполните описание',
        onlineApplicationExists: 'По данному ДТП уже имеется онлайн заявка!',
        fillOutAllFields: 'Заполните все поля',
        tryAgainLater:
          'Ошибка при попытке создания видеоконференции, попробуйте позже',
        onlineApplicationExistsContactOffice:
          'По данному ДТП уже имеется онлайн заявка, если остались вопросы, просим обратиться в наш офис',
        dataErrorSearchingCertificate: 'Ошибка в данных при поиске полиса',
        noValidCertificatesFound:
          'Полисов ОГПО ВТС, действовавших на момент происшествия, не найдено.',
        certificateNotFound:
          'Полис не найден в нашей базе. Проверьте введенные данные или обратитесь в наш ближайший офис',
        retryError: 'Ошибка. Повторите попытку еще раз',
        attachRequiredDocuments: 'Пожалуйста, прикрепите необходимые документы',
        failedToReceivePhoto: 'Не удалось получить фото',
        cannotIndicateAsVictimOrOwner:
          'Так как Вы подаете заявление как Виновник, вы не можете указывать себя как Потерпевшего или Владельца пострадавшего ТС',
        guiltyPersonCannotIndicate:
          'Как виновник, Вы не можете указать свое ТС как пострадавшее',
        incorrectPhoneNumber:
          'За текущим ИИН потерпевшего подтвержден другой номер телефона в личном кабинете сайта egov.kz. Внесите корректный номер телефона.',
        fillOutAllFieldsAndAttachPhotos:
          'Заполните все поля и прикрепите требуемые фотографии',
        noNotifications: 'Нет уведомлений',
        serviceTemporarilyUnavailable:
          'Сервис временно недоступен. Попробуйте позднее',
        captchaError: 'Ошибка captcha. Попробуйте позднее',
        invalidAccountNumberIBAN: 'Неверный номер счета (IBAN)',
        sendingData: 'Отправка данных...',
        applicationNotFound: 'Заявление не найдено',
        enterEmailAddress: 'Введите адрес электронной почты!',
        attachNotice: 'Прикрепите извещение!',
        attachApplication: 'Прикрепите заявление!',
        noticeSent: 'Извещение отправлено!',
        applicationSent: 'Заявление отправлено!',
        submittingDocumentsInfo:
          'При отправке заявления, также будут отправлены все документы, касающиеся этого страхового дела, в том числе «Извещение о намерении обращения к Страховому омбудсману».',
        applicationProcessed:
          'Заявление успешно отправлено и принято в обработку!',
        insuranceOmbudsmanWebsite: 'Сайт Страхового Омбудсмана',
        fileUploadError: 'Ошибка при загрузке файла',
        passwordLengthRequirement:
          'Пароль должен быть длиной не менее 6 символов',
        passwordNotEmpty: 'Пароль не может быть пустым',
        iinLength: 'ИИН состоит из 12 символов',
        personalAccountUpdate: 'Обновление личного кабинета!',
        registrationRestartInfo:
          'Если старые данные не проходят. Заново пройдите регистрацию для получения доступа к новым возможностям. Все ваши данные автоматически перенесутся.',
        passwordResetSuccess: 'Ваш пароль успешно сброшен!',
        newPasswordSentToPhoneNumber:
          'Новый пароль был отправлен на номер телефона',
      },
      extra: {
        yourEmail: 'Ваш e-mail',
        evaluationReport: 'Ознакомьтесь с отчетом об оценке',
        revaluationReport: 'Ознакомьтесь с отчетом о переоценке',
        downloadReport: 'Скачать отчет об оценке',
        downloadRevaluationReport: 'Скачать отчет о переоценке',
        answerNoAccepted: 'Ваш ответ «Нет» принят!',
        answerYesAccepted: 'Ваш ответ «Да» принят!',
        agreeWithAssessment: 'Согласны ли вы с нашей оценкой?',
        agreeWithReassessment: 'Согласны ли вы с нашей переоценкой?',
        disagreementStatement: 'Заявление о несогласии с оценкой',
        needAdditionalExamination: 'Вам необходим Дополнительный осмотр?',
        yes: 'Да',
        no: 'Нет',
        back: 'Назад',
        describeDisagreement: 'Кратко опишите с чем Вы не согласны',
        shortDescription: 'Краткое описание',
        describeSituation: 'Опишите ситуацию',
        attachDocumentsOptional: 'По желанию Вы можете прикрепить документы',
        attachDocuments: 'Прикрепить документ',
        send: 'Отправить',
        addDocument: 'Добавить документ',
        sendApplicationConfirmation:
          'Вы уверены, что хотите отправить заявление? Данное действие нельзя будет повторить или отменить.',
        cancel: 'Отмена',
        sendApplication: 'Отправить заявление',
        applicationSentSuccessfully:
          'Ваше заявление на переоценку успешно отправлено!',
        toPersonalAccount: 'В личный кабинет',
        howToReceivePayment: 'Каким способом вы хотите получить выплату?',
        cashPayment: 'Наличный расчет',
        cashlessPayment: 'Безналичный расчет',
        checkDataBeforeSending: 'Проверьте данные перед отправкой',
        confirmViaSMS: 'ПОДТВЕРДИТЬ С ПОМОЩЬЮ СМС',
        enterAccountNumber: 'Введите номер счета (IBAN)',
        applicantData: 'Данные заявителя',
        vehicleOwnerData: 'Данные владельца ТС',
        notifyInsuranceOmbudsman:
          '«Вы можете известить страховую компанию о намерении обращения к Страховому Омбудсману, для чего необходимо скачать шаблон бланка «Извещение о намерении обращения к Страховому омбудсману», заполнить и прикрепить его ниже».',
        sendNotification: 'Отправить извещение',
        sendNotificationConfirmation:
          'Вы уверены, что хотите отправить извещение? Данное действие нельзя будет повторить или отменить.',
        sendNotificationConfirmation2:
          'Вы уверены, что хотите отправить заявление? Данное действие нельзя будет повторить или отменить.',
        notificationSentSuccessfully:
          'Ваше извещение успешно отправлено, и принято в обработку!',
        resendApplicationInfo:
          'Отправить заявление повторно напрямую Страховому Омбудсману можно будет через 3 дня с момента отправки извещения',
        fullName: 'ФИО',
        phoneNumber: 'Номер телефона',
        insuranceNumber: 'Номер договора страхования',
        insuranceRegion: 'Регион происшествия',
        ownerFullName: 'ФИО владельца ТС',
        victimFullName: 'ФИО потерпевшего',
        victimStatus: 'Статус потерпевшего',
        inspectionRegion: 'Регион осмотра',
        inspectionAddress: 'Адрес осмотра',
        inspectionDate: 'Дата осмотра',
      },
      assessment: {
        sinceAttach:
          'Так как, по техпаспорту Вы не являетесь владельцем ТС, просим вас приложить доверенность от владельца',
        attachAttorney: 'Прикрепить доверенность',
        deleteDocument: 'Удалить документ',
        addressOfResidence: 'Адрес проживания',
        ownerIIN: 'ИИН владельца ТС',
        vehicleModel: 'Марка и модель ТС',
        iban: 'Номер счета (IBAN)',
        vehicleNumber: 'Номер ТС',
        accepted: 'Ответ принят! Ваш вопрос находится в работе!',
      },
      'Рассчитайте износ и пробег вашего ТС':
        'Рассчитайте износ и пробег вашего ТС',
      'Дата страхового случая': 'Дата страхового случая',
      'Адрес проживания заявителя': 'Адрес проживания заявителя',
      'Введите адрес проживания заявителя':
        'Введите адрес проживания заявителя',
      'Адрес происшествия': 'Адрес происшествия',
      'Введите адрес места происшествия': 'Введите адрес места происшествия',
      'Опишите ситуацию': 'Опишите ситуацию',
    },
  },
  kz: {
    sos: {
      'Дата, время и место осмотра будет согласовано с Вами в течение 3 рабочих дней. Ожидайте звонка от Контакт-центра АО «СК «Alatau City Garant».':
        'Сараптама күні, уақыты және орны Сізбен 3 жұмыс күні ішінде келісілетін болады. «Alatau City Garant» АҚ Байланыс орталығынан қоңырауды күтіңіз.',
      dtp: {
        title:
          'ЖКО-дан кейін онлайн сақтандыру төлемін қалай рәсімдеуге болады',
        video: 'Сақтандыру төлемін онлайн ресімдеу бойынша бейненұсқаулық',
      },
      notifications: {
        success: {
          applicationCreated: 'Сіздің ',
          applicationCreated2:
            'өтініміңіз сәтті құрылды және өңдеуге қабылданды',
          applicationCreatedFull:
            'Сіздің өтініміңіз сәтті құрылды және өңдеуге қабылданды.',
          app1: 'Сіздің хабарламаңыз сәтті жіберілді және өңдеуге қабылданды!',
          app2: 'Сіздің өтініміңіз сәтті жіберілді және өңдеуге қабылданды!',
        },
      },
      instructions: {
        waitThreeDays: 'Жібергеннен кейін 3 (үш) жұмыс күн күту керек. Егер:',
        finalResponseUnsatisfactory:
          'Сақтандыру компаниясы шағымыңызға сізді қанағаттандырмайтын түпкілікті жауап хат жіберді;',
        noFinalResponse:
          'Немесе сақтандыру компаниясы Сізге үш жұмыс күні ішінде нақты жауап жіберген жоқ.',
        contactOmbudsman:
          'Хабарлама жіберілгеннен кейін үш күн өткен соң, сіз сақтандыру омбудсманына «Қатынастарды реттеу туралы өтінішін» толтыру арқылы тікелей хабарласа аласыз.',
      },
      submissionStatus: {
        notificationSent: 'Хабарлама сәтті жіберілді және өңдеуге қабылданды!',
        ombudsmanApplicationSent:
          'Өтінішті тікелей сақтандыру омбудсманына хабарлама жіберілген сәттен бастап 3 жұмыс күнінен кейін жіберуге болады',
        downloadNote: 'Хабарлама үлгісін жүктеп алыңыз',
        downloadApp: 'Өтініш үлгісін жүктеп алыңыз',
        attachNote: 'Омбудсманға хабарлама тіркеу',
        attachApp: 'Өтінішті омбудсманға тіркеңіз',
      },
      website: {
        title: 'Сақтандыру Омбудсманының Сайты',
        claim: 'Омбудсменге үндеу',
        enterEmail:
          'Сақтандыру Омбудсманынан кері байланыс алу үшін поштаңызды енгізіңіз:',
        selectProcedure: 'Реттеу тәртібін таңдаңыз',
        withPoliceReport: 'МАИ хаттамасы болған кезде',
        europrotocol: 'Еурохаттама',
        soon: 'Жақында',
        withoutPoliceCall: 'МАИ-ді шақырмай',
        next: 'Әрі қарай',
        close: 'Жабу',
      },
      commissioner: {
        title:
          'Сандық апаттық комиссар жұмыс күндері сағат 9.00-ден 18.00-ге дейін қол жетімді*',
        authorizationRequired: 'Авторизация қажет*',
        vehicleCalculator:
          'Көлік құралдарының тозуы және жүгіру калькуляторлары',
        insuredEvent1: 'Сақтандыру жағдайы',
        insuredEvent2: 'Құжаттар',
        insuredEvent3: 'Жәбірленуші тараптың деректері',
        insuredEvent4: 'Тексеру немесе фото',
      },
      accidentDetails: {
        dateAndTime: 'Оқиға күні мен уақыты',
        insurance: 'Сақтандыру шарты',
        sendApplicationAs: 'Өтініш беру:',
        guiltyPerson: 'Кінәлі ретінде',
        victim: 'Жәбірленуші ретінде',
        selectPolicy: 'Полисті таңдаңыз',
        guiltyPersonIIN: 'Кінәлінің ЖСН-і',
        guiltyPersonVehicleNumber: 'Кінәлінің КҚ мемлекеттік нөмірі',
        enterAccidentAddress: 'Оқиға мекенжайын енгізіп жағдайды сипаттаңыз',
        note: 'Назар аударыңыз!',
        onlineApplicationNote:
          'Сақтандыру жағдайына онлайн-өтінімді ресімдеу тек бір жәбірленушінің шартымен ғана қолжетімді. Егер ЖКО - да жәбірленушілер саны біреуден көп болса, біздің жақын жердегі кеңсеге тікелей хабарласуыңызды сұраймыз.',
        trafficPoliceProtocol: 'Сот қаулысы',
        notRequiredAtTheTime: '* Өтініш беру кезінде міндетті емес',
        identityCard: 'Жеке куәлік *',
        techPassport: 'Техпаспорт *',
        trafficPoliceMaterials: 'ГАИ материалдары *',
        mandatoryToAttach: '* Бекітуге міндетті',
        addDocument: 'Құжат қосу',
        enterVictimDetails: 'Жәбірленуші тараптың мәліметтерін енгізіңіз',
        victimIIN: 'Жәбірленушінің ЖСН',
        victimContacts: 'Жәбірленушінің телефон нөмірі',
        damagedVehicleOwnerIIN: 'Зардап шеккен КҚ иесінің ЖСН',
        damagedVehicleNumber: 'Зардап шеккен КҚ нөмірі',
        owner: 'Иесі',
        attorneyInFact: 'Сенімхат бойынша өкіл',
        accidentParticipants: 'ЖКО қатысушылары',
        insuranceCompany: 'Сақтандыру компаниясы',
        lawyer: 'Адвокат',
        scheduleInspectionOrPhotos:
          'Сізге тексеру тағайындау керек пе әлде көлігіңізді өзіңіз суретке түсіресіз бе?',
        scheduleInspection: 'Тексеруді тағайындаңыз',
        takePhotosOnMyOwn: 'Өзіңіз суретке түсіріңіз',
        selectInspectionDetails:
          'Тексеру күнін, аймағын және мекенжайын таңдаңыз',
        scheduledInspectionDate: 'Жоспарланған тексеру күні',
        dearClient: 'Құрметті тұтынушы!',
        amountWillBePaid1:
          'Сақтандыру сомасы қажетті құжаттарды жинағаннан кейін ',
        amountWillBePaid2: '15 жұмыс күн ',
        amountWillBePaid3: 'ішінде төленеді!',
        collectionOfDocuments: 'Құжаттар тізімі',
        inspectionDateCannotExceed:
          'Жоспарланған тексеру күні өтініш берілген күннен бастап 5 күннен аспайтын аралықта болу керек',
        inspectionRegion: 'Тексеру жүргізілетін өңір',
        inspectionAddress: 'Тексеру жүргізу мекенжайы',
        fillInInspectionRegionAndAddress:
          'Тексеру аймақты және мекенжайын толтырыңыз',
        vehiclePhotos: 'Көліктің суреттері',
        frontView: 'Алдыңғы көрініс',
        backView: 'Артқы көрініс',
        leftView: 'Сол жақтағы көрініс',
        rightView: 'Оң жақтағы көрініс',
        reviewPhotosAndTakeNewOnesIfNecessary:
          'Фотосуретті тексеріңіз және қажет болған жағдайда жаңасын қайта түсіріңіз',
        applicationForAssessment: 'Бағалауға өтініш',
        checkCorrectnessOfFilledData:
          'Толтырылған деректердің дұрыстығын тексеріңіз',
        change: 'Өзгерту',
        applicantDetails: 'Өтініш берушінің деректері',
        victimDetails: 'Жәбірленушінің деректері',
        eventInsured: 'Сақтандыру жағдайы',
        inspection: 'Тексеру',
        submitApplication: 'Өтініш қалдыру',
        scheduleInspectionConfirmation:
          'Сіз өзіңіздің көлік құралыңызды тексеруді жоспарлағыңыз келетініне сенімдісіз бе?',
        scheduleInspectionConfirmation2:
          ' күніне тексеруді жоспарлағыңыз келетініне сенімдісіз бе?',
        sendingData: 'Деректерді жіберу...',
        applicationSentAndUnderConsideration: 'Өтінім жіберілді және қаралуда',
        applicationNumber: 'Сіздің №',
        applicationNumber2: ' өтініміңіз сәтті құрылды және өңдеуге қабылданды',
        listofApplications: 'Өтінімдер тізімі',
        homepage: 'Басты бет',
      },
      errors: {
        enterCorrectTime: 'Дұрыс уақытты енгізіңіз',
        selectRegion: 'Аймақты таңдаңыз',
        selectContractNumber: 'Шарт нөмірін таңдаңыз',
        selectDateAndTimeOfAccident: 'Оқиға күні мен уақытын таңдаңыз',
        fillOutDescription: 'Сипаттаманы толтырыңыз',
        onlineApplicationExists: 'Осы ЖКО бойынша онлайн өтінім бар!',
        fillOutAllFields: 'Барлық өрістерді толтырыңыз',
        tryAgainLater:
          'Бейнеконференция жасау кезінде қате пайда болды, кейінірек көріңіз',
        onlineApplicationExistsContactOffice:
          'Осы ЖКО бойынша онлайн өтінім тіркеліп қойылған, егер сұрақтар қалса, біздің кеңсеге хабарласуыңызды сұраймыз',
        dataErrorSearchingCertificate: 'Полисті іздеу кезіндегі деректер қате',
        noValidCertificatesFound:
          'Оқиға болған кезде әрекет еткен ОГПО ВТС полистері табылған жоқ.',
        certificateNotFound:
          'Полис біздің базада табылған жоқ. Енгізілген деректерді тексеріңіз немесе жақын жердегі кеңсеге хабарласыңыз',
        retryError: 'Қате. Әрекетті тағы бір рет қайталаңыз',
        attachRequiredDocuments: 'Міндетті құжаттарды тіркеңіз',
        failedToReceivePhoto: 'Фотосуретті алу мүмкін болмады',
        cannotIndicateAsVictimOrOwner:
          'Сіз кінәлі ретінде өтініш бергендіктен, сіз өзіңізді Жәбірленуші немесе Зардап шеккен КҚ иесі ретінде көрсете алмайсыз',
        guiltyPersonCannotIndicate:
          'Кінәлі ретінде сіз өзіңіздің көлігіңізді Жәбірленуші көлік ретінде көрсете алмайсыз',
        incorrectPhoneNumber:
          'Жәбірленушінің ағымдағы ЖСН үшін, egov.kz сайтында жеке кабинетінде басқа телефон нөмірі расталды. Дұрыс телефон нөмірін енгізіңіз.',
        fillOutAllFieldsAndAttachPhotos:
          'Барлық өрістерді толтырыңыз және қажетті фотосуреттерді тіркеңіз',
        noNotifications: 'Хабарламалар жоқ',
        serviceTemporarilyUnavailable:
          'Қызмет уақытша қол жетімді емес. Кейінірек көріңіз',
        captchaError: 'Captcha қатесі. Кейінірек көріңіз',
        invalidAccountNumberIBAN: 'Шот нөмірі дұрыс емес (IBAN)',
        sendingData: 'Деректерді жіберу...',
        applicationNotFound: 'Өтініш табылмады',
        enterEmailAddress: 'Электрондық пошта мекенжайын енгізіңіз!',
        attachNotice: 'Хабарламаны тіркеңіз!',
        attachApplication: 'Өтінішті тіркеңіз!',
        noticeSent: 'Хабарлама жіберілді!',
        applicationSent: 'Өтініш жіберілді!',
        submittingDocumentsInfo:
          'Өтінішті жіберген кезде осы сақтандыру ісіне қатысты барлық құжаттар, соның ішінде «Сақтандыру омбудсманына жүгіну ниеті туралы хабарлама» жіберілетін болады.',
        applicationProcessed: 'Өтініш сәтті жіберілді және өңдеуге қабылданды!',
        insuranceOmbudsmanWebsite: 'Сақтандыру Омбудсманінің Сайты',
        fileUploadError: 'Файлды жүктеу кезіндегі қате',
        passwordLengthRequirement:
          'Құпия сөз кем дегенде 6 таңбадан тұруы керек',
        passwordNotEmpty: 'Құпия сөз бос болуы мүмкін емес',
        iinLength: 'ЖСН 12 таңбадан тұрады',
        personalAccountUpdate: 'Жеке кабинетті жаңарту!',
        registrationRestartInfo:
          'Егер ескі деректер өтпесе. Жаңа мүмкіндіктерге қол жеткізу үшін қайта тіркеліңіз. Сіздің барлық деректеріңіз автоматты түрде ауысады.',
        passwordResetSuccess: 'Құпия сөзіңіз сәтті қалпына келтірілді!',
        newPasswordSentToPhoneNumber:
          'Жаңа құпия сөз телефон нөміріне жіберілді',
      },
      extra: {
        yourEmail: 'Сіздің e-mail',
        evaluationReport: 'Бағалау туралы есепті қараңыз',
        revaluationReport: 'Қайта бағалау туралы есепті қараңыз',
        downloadReport: 'Бағалау туралы есепті жүктеп алыңыз',
        downloadRevaluationReport: 'Қайта бағалау туралы есепті жүктеп алыңыз',
        answerNoAccepted: 'Сіздің «Жоқ» жауабыңыз қабылданды!',
        answerYesAccepted: 'Сіздің «Иә» жауабыңыз қабылданды!',
        agreeWithAssessment: 'Сіз біздің бағалауымызбен келісесіз бе?',
        agreeWithReassessment: 'Сіз біздің қайта бағалауымызбен келісесіз бе?',
        disagreementStatement: 'Бағалау туралы есепке келісім беру',
        needAdditionalExamination: 'Сізге қосымша тексеріс қажет пе?',
        yes: 'Иә',
        no: 'Жоқ',
        back: 'Артқа',
        describeDisagreement: 'Сіз немен келіспейтініңізді қысқаша сипаттаңыз',
        shortDescription: 'Қысқаша сипаттама',
        describeSituation: 'Жағдайды сипаттаңыз',
        attachDocumentsOptional: 'Қаласаңыз құжаттарды қоса аласыз',
        attachDocuments: 'Құжат тіркеу',
        send: 'Жіберу',
        addDocument: 'Құжат қосу',
        sendApplicationConfirmation:
          'Сіз өтініш жібергіңіз келетініне сенімдісіз бе? Бұл әрекетті қайталауға немесе жоюға болмайды.',
        cancel: 'Бас тарту',
        sendApplication: 'Жіберу',
        applicationSentSuccessfully: 'Сіздің өтінішіңіз сәтті жіберілді!',
        toPersonalAccount: 'Жеке кабинетке',
        howToReceivePayment: 'Төлемді қандай жолмен алғыңыз келеді?',
        cashPayment: 'Нақты төлем',
        cashlessPayment: 'Нақтылықсыз төлем',
        checkDataBeforeSending: 'Жібермес бұрын деректерді тексеріңіз',
        confirmViaSMS: 'СМС АРҚЫЛЫ РАСТАУ',
        enterAccountNumber: 'Шот нөмірін енгізіңіз (IBAN)',
        applicantData: 'Өтініш берушінің деректері',
        vehicleOwnerData: 'Көлік иесінің деректері',
        notifyInsuranceOmbudsman:
          '«Сіз сақтандыру компаниясына сақтандыру омбудсманына жүгіну ниеті туралы хабарлай аласыз, ол үшін "сақтандыру омбудсманына жүгіну ниеті туралы хабарлама" бланкінің үлгісін жүктеп алып, оны толтырып, төменде тіркеп қоюыңыз қажет».',
        sendNotification: 'Хабарлама жіберу',
        sendNotificationConfirmation:
          'Сіз хабарлама жібергіңіз келетініне сенімдісіз бе? Бұл әрекетті қайталауға немесе жоюға болмайды.',
        sendNotificationConfirmation2:
          'Сіз өтініш жібергіңіз келетініне сенімдісіз бе? Бұл әрекетті қайталауға немесе жоюға болмайды.',
        notificationSentSuccessfully:
          'Сіздің хабарламаңыз сәтті жіберілді және өңдеуге қабылданды!',
        resendApplicationInfo:
          'Өтінішті сақтандыру омбудсманына тікелей қайта жіберуге, хабарлама жіберілген сәттен бастап 3 күннен кейін болады',
        fullName: 'Аты-жөні',
        phoneNumber: 'Телефон нөмірі',
        insuranceNumber: 'Сақтандыру шартының нөмірі',
        insuranceRegion: 'Оқиға аймағы',
        ownerFullName: 'Көлік иегерінің аты-жөні',
        victimFullName: 'Жәбірленушінің аты-жөні',
        victimStatus: 'Жәбірленушінің мәртебесі',
        inspectionRegion: 'Көлік тексеру аймағы',
        inspectionAddress: 'Көлік тексеру мекенжайы',
        inspectionDate: 'Көлік тексеру күні',
      },
      assessment: {
        sinceAttach:
          'Техникалық паспорт бойынша Сіз көлік иесі емессіз, сізден көлік иесінен сенімхат қоса жүктеуіңізді сұраймыз',
        attachAttorney: 'Сенімхатты тіркеу',
        deleteDocument: 'Құжатты жою',
        addressOfResidence: 'Тұрғылықты мекен-жайы',
        ownerIIN: 'Көлік иесінің ЖСН',
        vehicleModel: 'Көлік маркасы және моделі',
        iban: 'Шот нөмірі (IBAN)',
        vehicleNumber: 'Көлік нөмірі',
        accepted: 'Жауап қабылданды! Сіздің сұрағыңыз жұмыста!',
      },
      'Рассчитайте износ и пробег вашего ТС':
        'Көлік құралының тозуы мен жүру мөлшерін есептеңіз',
      'Дата страхового случая': 'Сақтандыру жағдайы күні',
      'Адрес проживания заявителя': 'Өтініш берушінің тұрғылықты мекенжайы ',
      'Введите адрес проживания заявителя':
        'Өтініш берушінің тұрғылықты мекенжайын енгізіңіз',
      'Адрес происшествия': 'Оқиға орын алған мекенжай',
      'Введите адрес места происшествия': 'Оқиға мекенжайын енгізіңіз',
      'Опишите ситуацию': 'Жағдайды сипаттаңыз',
    },
  },
  en: {
    sos: {
      dtp: {
        title:
          'How to apply for an online insurance payment after a traffic accident',
        video: 'Video instruction on making insurance payments online',
      },
      notifications: {
        success: {
          applicationCreated: 'Your application with number ',
          applicationCreated2:
            'has been successfully created and is under processing.',
          applicationCreatedFull:
            'Your application has been successfully created and is under processing.',
          app1: 'Your notification has been successfully sent and accepted for processing!',
          app2: 'Your application has been successfully sent and accepted for processing!',
        },
      },
      instructions: {
        waitThreeDays:
          'After submission, you need to wait for 3 (three) business days. If:',
        finalResponseUnsatisfactory:
          'If the insurance company has sent you a letter with a final answer to your complaint and you are not satisfied with it:',
        noFinalResponse:
          'Or if the insurance company failed to send you a final response within three business days:',
        contactOmbudsman:
          "Three days after sending the Notice, you may contact the Insurance Ombudsman directly by completing 'Settlement Application'.",
      },
      submissionStatus: {
        notificationSent:
          'The notification has been successfully sent and is under consideration!',
        ombudsmanApplicationSent:
          'You may send your application directly to the insurance ombudsman within 3 business days from the date of sending the notice.',
        downloadNote: 'Download the notification template',
        downloadApp: 'Download application template',
        attachNote: 'Attach the notification to the Ombudsman',
        attachApp: 'Attach application for the ombudsman',
      },
      website: {
        title: 'Insurance Ombudsman Website',
        claim: 'File a claim with the ombudsman',
        enterEmail:
          'Please enter your email to receive feedback from the Insurance Ombudsman:',
        selectProcedure: 'Select settlement procedure',
        withPoliceReport: 'If there is a traffic police report',
        europrotocol: 'Europrotocol',
        soon: 'Soon',
        withoutPoliceCall: 'Without calling the traffic police',
        next: 'Next',
        close: 'Close',
      },
      commissioner: {
        title:
          'The digital emergency commissioner is available from 9:00 a.m. to 6:00 p.m. on weekdays*',
        authorizationRequired: 'Authorization required*',
        vehicleCalculator: 'Vehicle wear and mileage calculator',
        insuredEvent1: 'Event insured',
        insuredEvent2: 'Documents',
        insuredEvent3: 'Data of the injured party',
        insuredEvent4: 'Inspection or photo',
      },
      accidentDetails: {
        dateAndTime: 'Date and time of accident',
        insurance: 'Insurance contract',
        sendApplicationAs: 'Send application as:',
        guiltyPerson: 'Guilty person',
        victim: 'Victim',
        selectPolicy: 'Select certificate',
        guiltyPersonIIN: 'IIN of guilty person',
        guiltyPersonVehicleNumber: 'State number of guilty person’s vehicle',
        enterAccidentAddress:
          'Please enter address of the accident and provide details',
        note: 'Attention!',
        onlineApplicationNote:
          'Filling out an online application for an event insured is available for one victim only. Should the number of victims in an accident exceed one, we recommend you visiting our nearest office.',
        trafficPoliceProtocol: 'Court decision',
        notRequiredAtTheTime: '* Not required at the time of application',
        identityCard: 'Identification card *',
        techPassport: 'Technical passport *',
        trafficPoliceMaterials: 'Materials of traffic police *',
        mandatoryToAttach: '* Required to be attached',
        addDocument: 'Add document',
        enterVictimDetails: 'Please, enter the details of the injured party',
        victimIIN: 'IIN of victim',
        victimContacts: 'Victim contacts',
        damagedVehicleOwnerIIN: 'IIN of the owner of the damaged vehicle',
        damagedVehicleNumber: 'Number of damaged vehicle',
        owner: 'Owner',
        attorneyInFact: 'Attorney-in-fact',
        accidentParticipants: 'Participants in accident',
        insuranceCompany: 'Insurance Company',
        lawyer: 'Lawyer',
        scheduleInspectionOrPhotos:
          'Do you need to schedule an inspection or will you take photos of the vehicle on your own?',
        scheduleInspection: 'Schedule inspection',
        takePhotosOnMyOwn: 'Take photos on my own',
        selectInspectionDetails:
          'Please, select date, region and address of inspection',
        scheduledInspectionDate: 'Dare of scheduled inspection',
        dearClient: 'Dear client!',
        amountWillBePaid1: 'The insured amount will be paid within ',
        amountWillBePaid2: '15 working days ',
        amountWillBePaid3: 'after collecting the required documents!',
        collectionOfDocuments: 'Collection of documents',
        inspectionDateCannotExceed:
          'The date of scheduled inspection cannot exceed 5 days from the date of application',
        inspectionRegion: 'Region of inspection',
        inspectionAddress: 'Address of inspection',
        fillInInspectionRegionAndAddress:
          'Please, fill in region and address of inspection',
        vehiclePhotos: 'Vehicle photos',
        frontView: 'Front view',
        backView: 'Back view',
        leftView: 'Left view',
        rightView: 'Right view',
        reviewPhotosAndTakeNewOnesIfNecessary:
          'Please, view the photos and take new ones if necessary',
        applicationForAssessment: 'Application for assessment',
        checkCorrectnessOfFilledData:
          'Please, check the correctness of the filled data',
        change: 'Change',
        applicantDetails: 'Applicant details',
        victimDetails: 'Victim details',
        eventInsured: 'Event insured',
        inspection: 'Inspection',
        submitApplication: 'Submit your application',
        scheduleInspectionConfirmation:
          'Are you sure you want to schedule your vehicle inspection for ',
        scheduleInspectionConfirmation2: ' ?',
        sendingData: 'Sending data...',
        applicationSentAndUnderConsideration:
          'The application has been sent and is under consideration',
        applicationNumber: 'Your application No.',
        applicationNumber2:
          ' has been successfully created and is being processed',
        listofApplications: 'List of applications',
        homepage: 'Home page',
      },
      errors: {
        enterCorrectTime: 'Please, enter the correct time',
        selectRegion: 'Please, select your region',
        selectContractNumber: 'Please, select contract number',
        selectDateAndTimeOfAccident:
          'Please, select the date and time of the accident',
        fillOutDescription: 'Please, fill out the description section',
        onlineApplicationExists:
          'An online application for this accident has already been created!',
        fillOutAllFields: 'Please, fill in all the fields',
        tryAgainLater:
          'An error occurred when you tried to create video conference, please try again later',
        onlineApplicationExistsContactOffice:
          'An online application for this accident has already been created; should you have any questions, please contact our office',
        dataErrorSearchingCertificate:
          'Data error occurred when searching for certificate',
        noValidCertificatesFound:
          'No valid LEGAL LIABILITY INSURANCE OF TRANSPORT OWNERS certificates were found at the time of the incident.',
        certificateNotFound:
          'The certificate was not found in our database. Please, verify the entered data or visit our nearest office',
        retryError: 'Error. Please, try again',
        attachRequiredDocuments: 'Please, attach required documents',
        failedToReceivePhoto: 'Failed to receive photo',
        cannotIndicateAsVictimOrOwner:
          'Since you are submitting an application as the Guilty Person, you cannot indicate yourself as the Victim or the Owner of the damaged vehicle',
        guiltyPersonCannotIndicate:
          'Since you are the Guilty Person, you cannot indicate your vehicle as the damaged one',
        incorrectPhoneNumber:
          'The current IIN of the victim is confirmed by another phone number in the personal account at egov.kz. Please, enter correct phone number.',
        fillOutAllFieldsAndAttachPhotos:
          'Please, fill out all fields and attach the corresponding photos',
        noNotifications: 'No notifications',
        serviceTemporarilyUnavailable:
          'Service is temporarily unavailable. Please, try again later',
        captchaError: 'Captcha error. Please, try again later',
        invalidAccountNumberIBAN: 'Invalid account number (IBAN)',
        sendingData: 'Sending data...',
        applicationNotFound: 'Application not found',
        enterEmailAddress: 'Please, enter your email address!',
        attachNotice: 'Please, attach notice!',
        attachApplication: 'Please, attach your application!',
        noticeSent: 'The notice has been sent!',
        applicationSent: 'The application has been sent!',
        submittingDocumentsInfo:
          'When submitting the application, all documents relating to the insurance case will also be sent. These documents also include “Notice of Intent to Contact the Insurance Ombudsman”.',
        applicationProcessed:
          'The application has been successfully sent and is being processed!',
        insuranceOmbudsmanWebsite: 'Website of Insurance Ombudsman',
        fileUploadError: 'Error occurred when uploading the file',
        passwordLengthRequirement:
          'Your password must contain at least 6 characters',
        passwordNotEmpty: 'Password cannot be empty',
        iinLength: 'IIN consists of 12 characters',
        personalAccountUpdate: 'Personal account update!',
        registrationRestartInfo:
          'If you are unable to proceed with the old data, please register again to get access to new features. All your data will be transferred automatically.',
        passwordResetSuccess: 'Your password has been successfully reset!',
        newPasswordSentToPhoneNumber:
          'New password has been sent to your phone number',
      },
      extra: {
        yourEmail: 'Your e-mail',
        evaluationReport: 'Check out the evaluation report',
        revaluationReport: 'Check out the revaluation report',
        downloadReport: 'Download the evaluation report',
        downloadRevaluationReport: 'Download the revaluation report',
        answerNoAccepted: "Your answer 'No' is accepted!",
        answerYesAccepted: "Your answer 'Yes' is accepted!",
        agreeWithAssessment: 'Do you agree with our assessment?',
        agreeWithReassessment: 'Do you agree with our reassessment?',
        disagreementStatement: 'Statement of disagreement with the assessment',
        needAdditionalExamination: 'Do you need an additional examination?',
        yes: 'Yes',
        no: 'No',
        back: 'Back',
        describeDisagreement: 'Briefly describe what you disagree with',
        shortDescription: 'Short description',
        describeSituation: 'Describe the situation',
        attachDocumentsOptional: 'If desired, you can attach documents',
        attachDocuments: 'Attach document',
        send: 'Send',
        addDocument: 'Add a document',
        sendApplicationConfirmation:
          'Are you sure you want to submit an application? This action cannot be repeated or canceled.',
        cancel: 'Cancel',
        sendApplication: 'Send',
        applicationSentSuccessfully:
          'Your application for revaluation has been successfully submitted!',
        toPersonalAccount: 'To your personal account',
        howToReceivePayment: 'How do you want to receive the payment?',
        cashPayment: 'Cash payment',
        cashlessPayment: 'Cashless payment',
        checkDataBeforeSending: 'Check the data before sending',
        confirmViaSMS: 'CONFIRM VIA SMS',
        enterAccountNumber: 'Enter the account number (IBAN)',
        applicantData: "Applicant's details",
        vehicleOwnerData: 'Vehicle owner data',
        notifyInsuranceOmbudsman:
          '"You can notify the insurance company of the intention to appeal to the Insurance Ombudsman, for which you need to download the template of the form "Notification of the intention to appeal to the Insurance Ombudsman", fill it out and attach it below".',
        sendNotification: 'Send a notification',
        sendNotificationConfirmation:
          'Are you sure you want to send a notification? This action cannot be repeated or canceled.',
        sendNotificationConfirmation2:
          'Are you sure you want to submit an application? This action cannot be repeated or canceled.',
        notificationSentSuccessfully:
          'Your notification has been successfully sent and accepted for processing!',
        resendApplicationInfo:
          'It will be possible to resend the application directly to the Insurance Ombudsman in 3 days from the date of sending the notification',
        fullName: 'Full name',
        phoneNumber: 'Phone number',
        insuranceNumber: 'Insurance contract number',
        insuranceRegion: 'The region of the incident',
        ownerFullName: 'Full name of the vehicle owner',
        victimFullName: 'Full name of the victim',
        victimStatus: 'The status of the victim',
        inspectionRegion: 'Inspection region',
        inspectionAddress: 'Inspection address',
        inspectionDate: 'Inspection date',
      },
      assessment: {
        sinceAttach:
          'Since, according to the technical passport, you are not the owner of the vehicle, we ask you to attach a power of attorney from the owner',
        attachAttorney: 'Attach a power of attorney',
        deleteDocument: 'Delete the document',
        addressOfResidence: 'Address of residence',
        ownerIIN: 'IIN of the vehicle owner',
        vehicleModel: 'Make and model of the vehicle',
        iban: 'Account number (IBAN)',
        vehicleNumber: 'Vehicle number',
        accepted: 'The answer is accepted! Your question is in the works!',
      },
      'Рассчитайте износ и пробег вашего ТС':
        'Calculate the wear and mileage of your vehicle',
      'Дата страхового случая': 'Date of the insured event',
      'Адрес проживания заявителя': 'Address of residence of the applicant',
      'Введите адрес проживания заявителя':
        'Write the address of residence of the applicant',
      'Адрес происшествия': 'Address of the accident',
      'Введите адрес места происшествия': 'Write the address of the accident',
      'Опишите ситуацию': 'Describe the situation',
    },
  },
};
export default insuranceResources;
